import { useEffect, useState } from 'react'
import { NativeScrollEvent, NativeSyntheticEvent } from 'react-native'

export const useIsScreenScrolled = (): {
  isScrolled: boolean
  handleScroll: ((event: NativeSyntheticEvent<NativeScrollEvent>) => void) | undefined
} => {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handler = (event: Event) => {
      const target = event.target as HTMLElement | Document | null
      let scrollTop = window.scrollY
      if (target instanceof HTMLElement) {
        scrollTop = Math.max(scrollTop, target.scrollTop)
      }
      const scrolled = scrollTop > 0
      setIsScrolled((prev) => (prev !== scrolled ? scrolled : prev))
    }
    window.addEventListener('scroll', handler, { passive: true, capture: true })
    return () => window.removeEventListener('scroll', handler, { capture: true })
  }, [])

  return { isScrolled, handleScroll: undefined }
}
